/*
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-12 17:29:47
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-24 10:39:43
 * @FilePath: /privacy-web/src/api/index.js
 */
import { restApi } from '@/api/http/base.js';
//const base = 'http://10.209.20.36:8888/privacy';//----测试
 const base = '/privacy';
export default {
  // 获取默认配置
  getDefaultConfig() {
    return restApi({ url: `${base}/api/v1/common/get_config`, method: 'get' });
  },
  // 上传文件
  uploadFileDsr(data) {
    return restApi({ url: `${base}/api/v1/common/up`, method: 'post', data });
  },
  // 获取上传文件的配置
  uploadFileConfig(param) {
    return restApi({ url: `${base}/api/v1/common/upload_file_config`, method: 'get', data: param });
  },
  // 发送验证码
  sendVerifyCode(param) {
    return restApi({ url: `${base}/api/v1/common/send_verify_code`, method: 'post', data: param });
  },
  // 提交验证
  submitAuth(param) {
    return restApi({ url: `${base}/api/v1/user/submit_auth`, method: 'post', data: param });
  },
  // 提交DSR意思问题反馈
  insertQuestion(param) {
    return restApi({ url: `${base}/api/v1/privacy/insert_question`, method: 'post', data: param });
  },
  // 上传文件
  uploadFile(param) {
    return restApi({ url: `${base}/api/v1/common/upload`, method: 'post', data: param });
  },
  // 获取图片配置
  getDict(param) {
    return restApi({ url: `${base}/api/v1/common/get_dict`, method: 'get', data: param });
  },
  // 获取图片下载链接
  downloadLink(param) {
    return restApi({ url: `${base}/api/v1/common/download_link`, method: 'get', params: param });
  },
  // 拿到滑块图案
  getImageVerifyCode(param) {
    return restApi({ url: `${base}/api/v1/user/verify_captcha`, method: 'post', data: param });
  },
  getCaptcha(param) {
    return restApi({ url: `${base}/api/v1/user/get_captcha`, method: 'post', data: param });
  },
  // 获取城市列表
  getCityList() {
    return restApi({ url: `${base}/api/v1/common/get_city`, method: 'get' });
  },
};
